import { Button, Modal } from 'antd';
import React from 'react';

const CreateModal = ({ showModal, setShowModal, handleClickEvent }) => {
  const handleCancel = () => {
    setShowModal(false);
  };

  const handleClick = () => {
    setShowModal(false);
    handleClickEvent();
  };
  return (
    <div id="create-instruction-type">
      <Modal
        maskClosable={false}
        centered
        open={showModal}
        footer={null}
        closable={false}
        width={420}
        getContainer={() =>
          // eslint-disable-next-line no-undef
          document.getElementById('create-instruction-type')
        }
      >
        <div>
          <h2>Create Instruction Type</h2>
          <p>Hey there! 👋 </p>
          <p>
            You are about to create a new instruction type hierarchy. This will
            help you organize and categorize your instruction types effectively.
          </p>
          <div className="form-buttons">
            <Button
              shape="round"
              className="cancel-button"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              shape="round"
              type="primary"
              className="save-button"
              onClick={handleClick}
            >
              Create
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CreateModal;
